var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.1667 56.5V51.1667C59.1667 46.1964 55.7673 42.0202 51.1667 40.836M41.8334 9.27536C45.7425 10.8577 48.5 14.6902 48.5 19.1667C48.5 23.6432 45.7425 27.4756 41.8334 29.058M45.8334 56.5C45.8334 51.53 45.8334 49.0449 45.0214 47.0847C43.9388 44.4711 41.8623 42.3946 39.2487 41.312C37.2884 40.5 34.8034 40.5 29.8334 40.5H21.8334C16.8633 40.5 14.3783 40.5 12.4181 41.312C9.80445 42.3946 7.72793 44.4711 6.64533 47.0847C5.83337 49.0449 5.83337 51.53 5.83337 56.5M36.5 19.1667C36.5 25.0577 31.7244 29.8333 25.8334 29.8333C19.9423 29.8333 15.1667 25.0577 15.1667 19.1667C15.1667 13.2756 19.9423 8.5 25.8334 8.5C31.7244 8.5 36.5 13.2756 36.5 19.1667Z",
    stroke: "#6A6A6A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.ce22e45f368d471cc7be56520a8dc1aa.svg";
export { ForwardRef as ReactComponent };